export const environment = {
  production: false,
  apiUrl: 'https://dev-api.okitobus.dev',
  tenantBaseHost: 'okitobus.dev',
  tenantPort: 4200,
};
